/** @example "lzgw0d9vgpkp4llvh5k" */
export const randomString = (radix = 36) => {
    return Date.now().toString(radix) + Math.ceil(Math.random() * 10e16).toString(radix);
};
